import { c as _c } from "react/compiler-runtime";
import Image from "@/components/ui/CardImage";
type Props = {
  className?: string;
  href?: string;
  label?: string;
  bottomImage?: string;
  bottomImageAlt?: string;
};
export default function FollowUsTwitter(t0) {
  const $ = _c(17);
  const {
    className: t1,
    href,
    label: t2,
    bottomImage: t3,
    bottomImageAlt: t4
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const label = t2 === undefined ? "Follow us on Twitter" : t2;
  const bottomImage = t3 === undefined ? "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png" : t3;
  const bottomImageAlt = t4 === undefined ? "Twitter" : t4;
  const t5 = `w-[170px] max-w-full text-white flex items-center justify-center gap-1 px-1 py-2 rounded-full shadow-[inset_0_1px_0_rgba(255,255,255,0.35)] bg-[#00ACEE] ${className}`;
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" /></svg>;
    $[0] = t6;
  } else {
    t6 = $[0];
  }
  let t7;
  if ($[1] !== label) {
    t7 = <span className="text-12-english-500 text-FFFFFF leading-none font-medium select-none">{label}</span>;
    $[1] = label;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  let t8;
  if ($[3] !== label || $[4] !== t5 || $[5] !== t7) {
    t8 = <div className={t5} role="button" aria-label={label}>{t6}{t7}</div>;
    $[3] = label;
    $[4] = t5;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== bottomImage || $[8] !== bottomImageAlt) {
    t9 = bottomImage && <div className="mt-2"><Image src={bottomImage} alt={bottomImageAlt} width={250} height={250} className="object-contain" /></div>;
    $[7] = bottomImage;
    $[8] = bottomImageAlt;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t8 || $[11] !== t9) {
    t10 = <div className="flex flex-col items-center gap-3 p-4">{t8}{t9}</div>;
    $[10] = t8;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  const buttonContent = t10;
  if (href) {
    let t11;
    if ($[13] !== buttonContent || $[14] !== href || $[15] !== label) {
      t11 = <a href={href} aria-label={label} className="inline-block w-full" target="_blank" rel="noopener noreferrer">{buttonContent}</a>;
      $[13] = buttonContent;
      $[14] = href;
      $[15] = label;
      $[16] = t11;
    } else {
      t11 = $[16];
    }
    return t11;
  }
  return buttonContent;
}